module.exports = __webpack_public_path__ + "img/file-icon-ppt.01f70735.svg";